import { connect } from 'react-redux';
import WsrReportsView from '../../../components/wsrReports/WsrReportsView';
import api from '../../../store/services/projects.service';

const mapStateToProps = () => ({
    fetchReports: (params) => api.getWsrReportsRequest(params),
});

export default connect(mapStateToProps)(WsrReportsView);
